import { theme, TimeSelection } from '@mi-front/ui';
import { useTimezone } from '../../../../../../../core/hooks';
import { useCursor } from '../../../stores/stream-screen.store';
import { useStreamSelection } from '../../../stores/useStreamSelection';
import { SelectionMenu } from './selection-menu/SelectionMenu';
import { useSelectionMenuPosition } from './useSelectionMenuPosition';

export function Selection() {
  const tz = useTimezone();
  const cursorTs = useCursor();
  const showMenu = !cursorTs;
  const { selection, setSelection } = useStreamSelection();
  const { tsA, tsB } = selection;

  const menuPosition = useSelectionMenuPosition();

  return (
    <TimeSelection
      tz={tz}
      tsA={tsA}
      tsB={tsB}
      onChange={({ tsA, tsB }) => setSelection(tsA, tsB)}
      menu={showMenu && <SelectionMenu />}
      color={theme.aqua}
      menuPosition={menuPosition}
    />
  );
}
